module.exports = __webpack_public_path__ + "img/5.bf335ab8.jpg";